<template>
  <div>
    <vs-row class="mb-5">
       <vs-collapse>
      <vs-collapse-item v-for="result in data" class="mb-3" :key="result.id">
        <div slot="header" v-if="result.isSuccess" class="text-primary font-bold">{{ result.description }}</div>
        <div v-else slot="header">
          {{ result.description }}
          <feather-icon v-if="!isCurrentReportId(result)" @click="goToReport(result)" icon="EditIcon" class="pl-1" svgClasses="cursor-pointer"></feather-icon>
        </div>
        <ul>
          <li v-for="message in result.messages" :key="message">
            <feather-icon icon="MinusIcon" svgClasses="pt-4"></feather-icon>
            <span class="font-bold pl-2 pb-2">{{ message }}</span>
          </li>
        </ul>
      </vs-collapse-item>
      </vs-collapse>
    </vs-row>
  </div>
</template>
<script>

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    currentReportId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    
  },
  methods: {
    goToReport(result) {
      this.$emit("closeSidebar");
      setTimeout(() => {
        this.$router.push({ name: 'drilling-staging-edit', params: { stagingDailyReportId: result.id, importationResults: this.data } });

      }, 200)
    },
    isCurrentReportId(result) {
      return result.id === this.currentReportId;
    }
  }
};
</script>
<style>
span.icon-header.vs-collapse-item--icon-header > .vs-icon
{
  font-size: 2rem;
}</style>
